import { LockClosedIcon } from '@heroicons/react/24/outline'
import ReactInputMask from '@mona-health/react-input-mask'
import parse from 'html-react-parser'
import { classNames } from '../../_helpers'
import { DESCRIPTION_CLASS, INFOTEXT_CLASS, INPUT_CLASS, LABEL_CLASS } from './styles'

type PropType = {
  label: string;
  value: string;
  className?: string;
  small?: boolean;
  setValue: (value: string) => void;
  isRequired?: boolean;
  vertical?: boolean;
  fullWidthInput?: boolean;
  readOnly?: boolean;
  hasHourMask?: boolean,
  disabled?: boolean,
  isPrivate?: boolean,
  numeric?: boolean,
  password?: boolean,
  mask?: string | any[]
  infotext?: string
  bottomDescription?: string
  placeholder?: string
}

const hourFirst = /[0-2]/;
const minFirst = /[0-5]/;
const hourOrMin = /[0-9]/;
export const HOUR_MASK = [hourFirst, hourOrMin, ":", minFirst, hourOrMin];

export const Textfield = ({ disabled, numeric, password, isPrivate, label, value, setValue, className, small, isRequired, readOnly, fullWidthInput, hasHourMask, mask = '', infotext, bottomDescription, placeholder }: PropType) => {
  return (
    <label className={classNames('block', className)}>
      <span className={classNames(LABEL_CLASS, 'mb-1.5', small ? 'text-xs' : 'text-sm')}>
        {isPrivate && (
          <LockClosedIcon className={'w-4 h-4 mr-2 shrink-0'} />
        )}
        {label}
      </span>
      {infotext && (
        <div className={classNames(INFOTEXT_CLASS, fullWidthInput ? 'max-w-none' : '')}>{parse(infotext)}</div>
      )}
      <ReactInputMask mask={hasHourMask ? HOUR_MASK : mask} alwaysShowMask value={value} onChange={(e: any) => setValue(e.target.value)} disabled={readOnly || disabled || false}>
        <input
          type={numeric ? 'number': (password ? 'password' : 'text')}
          required={isRequired}
          placeholder={placeholder}
          className={classNames(
            INPUT_CLASS,
            !fullWidthInput ? 'max-w-xl' : '',
            small ? 'text-xs' : 'text-sm'
          )}
        />
      </ReactInputMask>
      {bottomDescription && (
        <p className={classNames(DESCRIPTION_CLASS, fullWidthInput ? 'max-w-none' : '')}>{bottomDescription}</p>
      )}
    </label>
  )
}
